<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="form_laive validateClient">
        <div class="box_loader">
          <div class="loader"></div>
        </div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1 pt-0 mt-0"
        >
          <template v-slot:header>
            <h3 v-if="updateNameEstudio == false" class="mb-0">{{nameEstudio}}&nbsp;&nbsp;<base-button @click="clickUpdateName" type="" class="edit" size="sm" role="button">Actualizar nombre</base-button></h3>
            <form @submit.prevent="submitNameEstudio" v-if="updateNameEstudio">
              <div class="row">
                <div class="col-md-7">
                  <input class="form-control" name="name_estudio" id="name_estudio" minlength="4" maxlength="" type="text" placeholder="Nombre del Estudio" required="" v-model="nameEstudio">
                </div>
                <div class="col-md-5">
                  <button type="submit" class="btn base-button btn-primary btn-default my-0" style="background: #02A54F !important;border-color: #02A54F;">Actualizar nombre</button>
                  <button type="button" @click="cancelFormUpdate" class="btn base-button my-0">Cancelar</button>
                </div>
              </div>
            </form>
          </template>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <ul class="progressbar_vertical">
                  <li class="step_grupo active" data-text="Grupo objetivo">1</li>
                  <li class="step_grupo active" data-text="Preguntas">2</li>
                </ul>
              </div>
              <div class="col-md-10">
                  <div class="promotion_header d-none">
                    <h3>Elige la forma de definir tu muestra de estudio</h3>
                    <div class="box_access">
                      <div class="box_access__item" ref="create_group" @click="clickCreateGroup">
                        <div class="icon">
                          <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.91699 2.08331C4.91699 1.61918 5.10137 1.17406 5.42956 0.845876C5.75774 0.517688 6.20286 0.333313 6.66699 0.333313H11.3337C11.7978 0.333313 12.2429 0.517688 12.5711 0.845876C12.8993 1.17406 13.0837 1.61918 13.0837 2.08331V3.24998C13.0837 3.71411 12.8993 4.15923 12.5711 4.48742C12.2429 4.81561 11.7978 4.99998 11.3337 4.99998H6.66699C6.20286 4.99998 5.75774 4.81561 5.42956 4.48742C5.10137 4.15923 4.91699 3.71411 4.91699 3.24998V2.08331ZM6.66699 1.49998C6.51228 1.49998 6.36391 1.56144 6.25451 1.67083C6.14512 1.78023 6.08366 1.9286 6.08366 2.08331V3.24998C6.08366 3.40469 6.14512 3.55306 6.25451 3.66246C6.36391 3.77185 6.51228 3.83331 6.66699 3.83331H11.3337C11.4884 3.83331 11.6367 3.77185 11.7461 3.66246C11.8555 3.55306 11.917 3.40469 11.917 3.24998V2.08331C11.917 1.9286 11.8555 1.78023 11.7461 1.67083C11.6367 1.56144 11.4884 1.49998 11.3337 1.49998H6.66699Z" fill="#02A54F"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.50016 2.08331H2.5835C2.11937 2.08331 1.67425 2.26769 1.34606 2.59588C1.01787 2.92406 0.833496 3.36918 0.833496 3.83331V21.9166C0.833496 22.3808 1.01787 22.8259 1.34606 23.1541C1.67425 23.4823 2.11937 23.6666 2.5835 23.6666H15.4168C15.881 23.6666 16.3261 23.4823 16.6543 23.1541C16.9825 22.8259 17.1668 22.3808 17.1668 21.9166V3.83331C17.1668 3.36918 16.9825 2.92406 16.6543 2.59588C16.3261 2.26769 15.881 2.08331 15.4168 2.08331H12.5002V3.24998C12.5002 3.5594 12.3772 3.85615 12.1585 4.07494C11.9397 4.29373 11.6429 4.41665 11.3335 4.41665H6.66683C6.35741 4.41665 6.06067 4.29373 5.84187 4.07494C5.62308 3.85615 5.50016 3.5594 5.50016 3.24998V2.08331ZM3.75016 10.25C3.75016 10.0953 3.81162 9.9469 3.92102 9.8375C4.03041 9.7281 4.17879 9.66665 4.3335 9.66665H8.41683C8.57154 9.66665 8.71991 9.7281 8.82931 9.8375C8.93871 9.9469 9.00016 10.0953 9.00016 10.25C9.00016 10.4047 8.93871 10.5531 8.82931 10.6625C8.71991 10.7719 8.57154 10.8333 8.41683 10.8333H4.3335C4.17879 10.8333 4.03041 10.7719 3.92102 10.6625C3.81162 10.5531 3.75016 10.4047 3.75016 10.25ZM4.3335 6.74998C4.17879 6.74998 4.03041 6.81144 3.92102 6.92083C3.81162 7.03023 3.75016 7.1786 3.75016 7.33331C3.75016 7.48802 3.81162 7.6364 3.92102 7.74579C4.03041 7.85519 4.17879 7.91665 4.3335 7.91665H13.3752C13.5299 7.91665 13.6782 7.85519 13.7876 7.74579C13.897 7.6364 13.9585 7.48802 13.9585 7.33331C13.9585 7.1786 13.897 7.03023 13.7876 6.92083C13.6782 6.81144 13.5299 6.74998 13.3752 6.74998H4.3335ZM4.91683 14.9166V16.0833H6.0835V14.9166H4.91683ZM4.3335 13.75C4.17879 13.75 4.03041 13.8114 3.92102 13.9208C3.81162 14.0302 3.75016 14.1786 3.75016 14.3333V16.6666C3.75016 16.8214 3.81162 16.9697 3.92102 17.0791C4.03041 17.1885 4.17879 17.25 4.3335 17.25H6.66683C6.82154 17.25 6.96991 17.1885 7.07931 17.0791C7.18871 16.9697 7.25016 16.8214 7.25016 16.6666V14.3333C7.25016 14.1786 7.18871 14.0302 7.07931 13.9208C6.96991 13.8114 6.82154 13.75 6.66683 13.75H4.3335ZM13.0835 14.9166C13.0835 15.3808 12.8991 15.8259 12.5709 16.1541C12.2427 16.4823 11.7976 16.6666 11.3335 16.6666C10.8694 16.6666 10.4242 16.4823 10.0961 16.1541C9.76787 15.8259 9.5835 15.3808 9.5835 14.9166C9.5835 14.4525 9.76787 14.0074 10.0961 13.6792C10.4242 13.351 10.8694 13.1666 11.3335 13.1666C11.7976 13.1666 12.2427 13.351 12.5709 13.6792C12.8991 14.0074 13.0835 14.4525 13.0835 14.9166ZM11.3335 17.4355C10.1651 17.4355 7.8335 18.0573 7.8335 19.2916V20.75H14.8335V19.2916C14.8335 18.0573 12.5019 17.4355 11.3335 17.4355Z" fill="#02A54F"/>
                            </svg>
                        </div>
                        <div class="body">
                          <h4 class="title">Definir grupo objetivo</h4>
                          <p class="text">Selecciona las características de tu muestra.</p>
                        </div>
                      </div>

                      <div class="box_access__item" ref="upload_file" @click="clickUploadFile">
                        <div class="icon">
                          <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.0277 6.02752L11.7952 0.79502C11.3943 0.394187 10.8418 0.166687 10.2677 0.166687H2.50016C1.3085 0.166687 0.34433 1.14169 0.34433 2.33335L0.333496 19.6667C0.333496 20.8584 1.29766 21.8334 2.48933 21.8334H15.5002C16.6918 21.8334 17.6668 20.8584 17.6668 19.6667V7.56585C17.6668 6.99169 17.4393 6.43919 17.0277 6.02752ZM12.0335 14.25H10.0835V17.5C10.0835 18.0959 9.596 18.5834 9.00016 18.5834C8.40433 18.5834 7.91683 18.0959 7.91683 17.5V14.25H5.97766C5.49016 14.25 5.25183 13.665 5.5985 13.3292L8.63183 10.3067C8.8485 10.1009 9.18433 10.1009 9.401 10.3067L12.4235 13.3292C12.7485 13.665 12.5102 14.25 12.0335 14.25ZM11.1668 7.75002C10.571 7.75002 10.0835 7.26252 10.0835 6.66669V1.79169L16.0418 7.75002H11.1668Z" fill="#6E6E6E"/>
                          </svg>
                        </div>
                        <div class="body">
                          <h4 class="title">Cargar grupo objetivo</h4>
                          <p class="text">Sube los clientes mediante un archivo</p>
                        </div>
                      </div>

                    </div>
                    <base-button type="primary" disabled native-type="button" class="btn-default my-0 initCreatePromo" @click="nextStep">Aceptar</base-button>
                  </div>

                  <div class="box_step_grupo d-none">
                    <h3>Definición del Grupo objetivo</h3>
                    <form @submit.prevent="createGrupo">
                      <label class="col-form-label form-control-label">Distribuidoras:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allDis" class="custom-control-input" value="allDis" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allDis" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in distribuidoras" :key="item.idDistribuidora">
                          <input :id="item.idDistribuidora" class="custom-control-input item" :value="item.idDistribuidora" type="checkbox" v-model="selectDistribuidoras">
                          <label :for="item.idDistribuidora" class="custom-control-label"><strong> {{ item.razonSocial }}</strong></label>
                        </div>
                      </div>

                      <label class="col-form-label form-control-label">Segmentos:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allSegment" class="custom-control-input" value="allSegment" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allSegment" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in segmentos" :key="item.codigo+`-segmentos`">
                          <input :id="item.nombre+`-segmentos`" class="custom-control-input item" :value="item.codigo" type="checkbox" v-model="selectSegmentos">
                          <label :for="item.nombre+`-segmentos`" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>

                      <label class="col-form-label form-control-label">Giro de Negocio:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allGiros" class="custom-control-input" value="allGiros" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allGiros" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in giros" :key="item.codigo+`-giros`">
                          <input :id="item.nombre+`-giros`" class="custom-control-input item" :value="item.codigo" type="checkbox" v-model="selectGiros">
                          <label :for="item.nombre+`-giros`" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>

                      <label class="col-form-label form-control-label">Tipo de Cliente:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allTipoCliente" class="custom-control-input" value="allTipoCliente" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allTipoCliente" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in tiposCliente" :key="item.codigo+`-tipocliente`">
                          <input :id="item.codigo+`-tipocliente`" class="custom-control-input item" :value="item.codigo" type="checkbox" v-model="selectTipoCliente">
                          <label :for="item.codigo+`-tipocliente`" class="custom-control-label"><strong> {{ item.nombre.toLowerCase() }}</strong></label>
                        </div>
                      </div>

                      <label class="col-form-label form-control-label">Cluster:</label>
                      <div class="list_group">
                        <div class="custom-control custom-checkbox">
                          <input id="allCluster" class="custom-control-input" value="allCluster" type="checkbox" @change="selectAllCheckboxes($event)">
                          <label for="allCluster" class="custom-control-label"><strong>Todos</strong></label>
                        </div>
                        <div class="custom-control custom-checkbox" v-for="item in clusters" :key="item.codigo+`-cluster`">
                          <input :id="item.nombre+`-cluster`" class="custom-control-input item" :value="item.codigo" type="checkbox" v-model="selectCluster">
                          <label :for="item.nombre+`-cluster`" class="custom-control-label"><strong> {{ item.nombre }}</strong></label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Departamento:</label>
                            <select class="form-control" style="display: inline-block;height: 43px;" name="departamento_select" v-model="grupoObjetivo.departamento" @change="changeDeparments">
                              <option value="" selected disabled>Selecconar</option>
                              <option v-for="item in departamentos" :value="item.codigo" :key="item.codigo">
                                  {{ item.nombre }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Provincia:</label>
                            <select class="form-control" style="display: inline-block;height: 43px;" name="provincia_select" v-model="grupoObjetivo.provincia" @change="changeProvincias">
                              <option value="" selected disabled>Selecconar</option>
                              <option v-for="item in provincias" :value="item.codigo" :key="item.codigo">
                                  {{ item.nombre }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label class="col-form-label form-control-label">Distrito:</label>
                            <select class="form-control" style="display: inline-block;height: 43px;" name="distrito_select" v-model="grupoObjetivo.distrito">
                              <option value="" selected disabled>Selecconar</option>
                              <option v-for="item in distritos" :value="item.codigo" :key="item.codigo">
                                  {{ item.nombre }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Fecha de Inicio:</label>
                          <base-input addon-left-icon="ni ni-calendar-grid-58" name="fecha_inicio">
                            <flat-picker :config="configDate" class="form-control datepicker" required v-model="grupoObjetivo.fechaInicio"></flat-picker>
                          </base-input>
                        </div>
                        <div class="col-md-4">
                          <label class="col-form-label form-control-label">Fecha de Fin:</label>
                          <base-input addon-left-icon="ni ni-calendar-grid-58" name="fecha_fin">
                            <flat-picker :config="configDate" class="form-control datepicker" required v-model="grupoObjetivo.fechaFin"></flat-picker>
                          </base-input>
                        </div>
                      </div>
                      <base-button type="" @click="backStep" >&lt; Regresar</base-button>
                      <base-button type="primary" native-type="submit" class="btn-default my-0">Aceptar</base-button>
                    </form>
                  </div>

                  <div class="box_step_resumen d-none">
                    <div>
                      <h3>Resumen de la muestra</h3>
                      <el-table :data="tableData" row-key="detalleStudio" empty-text="No se encontraron resultados" header-row-class-name="thead-light" >
                        <el-table-column
                          v-for="column in tableColumns"
                          :key="column.label"
                          v-bind="column"
                        >
                        </el-table-column>
                      </el-table>
                      <br>
                      <base-button type="" @click="backStep" >&lt; Regresar</base-button>
                      <base-button type="primary" native-type="submit" class="btn-default my-0" @click="createPoll">Siguiente</base-button>
                    </div>
                  </div>

                  <div class="box_step_poll">
                    <QuestionCard class='mt-2' v-for="(card,index) in this.dataPreguntas.preguntas"
                    :key="card.id"
                    :questionTypes="tipoPreguntas"
                    :question="card"
                    :questions="this.dataPreguntas.preguntas"
                    :indexCard="index"
                    @changed="changeQuestionCard"
                    ></QuestionCard>
                    <div class='d-flex mt-3 w-100'>
                      <base-button type="primary" native-type="button" class="btn-default my-0" @click="registrarDatapreguntas()">Actualizar y puiblicar</base-button>
                    </div>
                  </div>

                  <div class="box_step_upload d-none">
                    <h3>Cargar Excel</h3>
                    <div>
                      <dropzone-file-upload v-model="filePromo" :options="configDropZone" @addedfile="addFile" class="custom_file_import" ></dropzone-file-upload>
                      <base-button type="" @click="backStep" >&lt; Regresar</base-button>
                      <base-button type="primary" native-type="button" class="btn-default my-0" @click="uploadFilePromo">Cargar Promociones</base-button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import {mapActions,mapGetters} from 'vuex';
import axios from "axios";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import { useToast } from "vue-toastification";
import Notification from "@/components/Notification";
import flatPicker from "vue-flatpickr-component";
import {Spanish} from 'flatpickr/dist/l10n/es.js';
import "flatpickr/dist/flatpickr.css";
import swal from "sweetalert2";
import QuestionCard from "../Components/QuestionCard";
import {
  ElTable,
  ElTableColumn,
  ElSelect,
  ElOption,
  ElInput,
} from "element-plus";
export default {
  components: {
    RouteBreadCrumb,
    flatPicker,
    DropzoneFileUpload,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
    [ElTable.name]: ElTable,
    [ElInput.name]: ElInput,
    [ElTableColumn.name]: ElTableColumn,
    QuestionCard
  },
  created(){
    const $this = this
    const idStudio = this.$route.params.id
    this.grupoObjetivo.idEstudio = Number(idStudio)
    this.nameEstudio = this.$route.query.name
  },
  methods: {
    ...mapActions({
        getDistributorList: 'distribuidora/getList',
        getTipoPreguntaList: 'encuesta/getTipoPregunta',
        getDataPreguntasList:'encuesta/getDataPreguntas',
        setDataPreguntas:'encuesta/setDataPreguntas',
        insDataPreguntas:'encuesta/insDataPreguntas'
    }),
    async getdataPreguntasLista(){
      const idStudio = this.$route.params.id;
      let result = await this.getDataPreguntasList(idStudio);
      if(result.data ? (result.data.preguntas.length > 0 ? true : false ): false) {
        this.dataPreguntas.isNew = true
        this.dataPreguntas = result.data
        document.querySelector(".form_laive").classList.remove("validateClient")
      }else {
          const idStudio = this.$route.params.id;
          this.dataPreguntas = {
          idEstudio:(+idStudio), isNew:true,
          preguntas:[ { "id":"preg_1", "title":"","type":"multiple", "required":false, "options":[ ], "condition":null }]
          }
      }
    },
    async actualizarDatapreguntas(){
        try{
          console.log('actualizar');
          let result = await this.setDataPreguntas(this.dataPreguntas);
        }
        catch(ex){console.log(ex)}
    },
    async registrarDatapreguntas(){
        try{
            const $this = this
            console.log('registrar');
            document.querySelector(".form_laive").classList.add("validateClient")
            let result = await this.insDataPreguntas(this.dataPreguntas);
            if(result.data){
              document.querySelector(".form_laive").classList.remove("validateClient")
              setTimeout(() => {
                $this.$router.replace({ name: "Reporte de Encuestas"})
              }, 2000)
            }
        }
        catch(ex){console.log(ex)}
    },
    async getTipoDePregunta(){
        let result = await this.getTipoPreguntaList();
        if(result.data) {this.tipoPreguntas = result.data;}
    },
    async changeQuestionCard(a,b){
        if(!this.dataPreguntas.isNew){
            await this.actualizarDatapreguntas();
        }
    },
    createGrupo(values){
      const $this = this
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      this.grupoObjetivo.idDistribuidora = this.selectDistribuidoras.join(',')
      this.grupoObjetivo.tipoCliente = this.selectTipoCliente.join(',')
      this.grupoObjetivo.giroNegocio = this.selectGiros.join(",")
      this.grupoObjetivo.segmento = this.selectSegmentos.join(",")
      this.grupoObjetivo.cluster = this.selectCluster.join(",")
      console.log(this.grupoObjetivo)
      let updateEstudio = process.env.VUE_APP_API_URL+"/estudio/actualizar"
      document.querySelector(".form_laive").classList.add("validateClient")
      axios.post(updateEstudio, this.grupoObjetivo, config)
      .then(function(response){
        let dataResumen = response.data.resumen
        $this.tableData = dataResumen
          // Create
        $this.resumeGrupo = true
        document.querySelector(".form_laive").classList.remove("validateClient")
        document.querySelector(".box_step_grupo").classList.add("d-none")
        document.querySelector(".box_step_resumen").classList.remove("d-none")
      })
    },
    createPoll(){
      if(!this.resumeGrupo) return
      document.querySelectorAll(".progressbar_vertical .step_grupo")[1].classList.add("active")
      document.querySelector(".box_step_resumen").classList.add("d-none")
      document.querySelector(".box_step_poll").classList.remove("d-none")
      console.log(this.resumeGrupo)
    },
    uploadFilePromo(){
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      if(File.prototype.isPrototypeOf(this.filePromo)){
        let $this = this
        let uploadImage = process.env.VUE_APP_API_URL+"/promocion/carga-cliente"
        let formData = new FormData();
        formData.append("file", this.filePromo);
        document.querySelector(".form_laive").classList.add("validateClient")
        axios.post(uploadImage, formData, config)
        .then(function(response){
          console.log("file subido")
          const idGrupo = response.data.idGrupo
          const content = {
            component: Notification,
            props: {
              icon: "ni ni-bell-55",
              text: "Se Creo el Grupo objetivo",
              type: "success",
            },
          };
          const toast = useToast();
          toast(content, {
            hideProgressBar: true,
            icon: false,
            closeButton: false,
            position: "top-right",
          });
          document.querySelectorAll(".progressbar_vertical .step_grupo")[1].classList.add("active")
          document.querySelector(".box_step_upload").classList.add("d-none")
          document.querySelector(".box_step_resumen").classList.remove("d-none")
        })
      }else{
        const swalError = swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-fill",
          },
          buttonsStyling: false,
        });
        swalError.fire({
          title: `No se ha cargado el documento`,
          confirmButtonText: "Ok",
        });
      }
    },
    clickCreateGroup(event){
      const select = this.$refs.create_group
      document.querySelectorAll(".box_access__item ").forEach(element => {
        element.classList.remove("active")
      });
      if(select.classList.contains("active")){
        select.classList.remove("active")
        this.createGroup = false
      }else{
        select.classList.add("active")
        this.createGroup = true
      }
      document.querySelector(".initCreatePromo").disabled = false
    },
    clickUploadFile(event){
      const select = this.$refs.upload_file
      document.querySelectorAll(".box_access__item ").forEach(element => {
        element.classList.remove("active")
      });
      select.classList.toggle("active")
      this.createGroup = false
      this.uploadFile = true
      document.querySelector(".initCreatePromo").disabled = false
    },
    nextStep(event){
      if(this.createGroup){
        document.querySelector(".promotion_header").classList.add("d-none")
        document.querySelector(".box_step_grupo").classList.remove("d-none")
        document.querySelectorAll(".progressbar_vertical .step_grupo")[0].classList.add("active")
      }else if(this.uploadFile){
        document.querySelector(".promotion_header").classList.add("d-none")
        document.querySelector(".box_step_upload").classList.remove("d-none")
        document.querySelectorAll(".progressbar_vertical .step_grupo")[0].classList.add("active")
      }
      else{
        const swalError = swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-fill",
          },
          buttonsStyling: false,
        });
        swalError.fire({
          title: `Selccione una opción`,
          confirmButtonText: "Ok",
        });
      }
    },
    backStep(event){
      const select = event.target
      const parent = select.parentElement.parentElement
      document.querySelectorAll(".box_access__item ").forEach(element => {
        element.classList.remove("active")
      });
      if(parent.classList.contains("box_step_grupo")){
        this.createGroup = false
        parent.classList.add("d-none")
        document.querySelector(".promotion_header").classList.remove("d-none")
      }
      if(parent.classList.contains("box_step_resumen")){
        parent.classList.add("d-none")
        this.resumeGrupo = false
        document.querySelector(".box_step_grupo").classList.remove("d-none")
      }
      if(parent.classList.contains("box_step_upload")){
        this.createGroup = false
        this.resumeGrupo = false
        parent.classList.add("d-none")
        document.querySelector(".promotion_header").classList.remove("d-none")
      }
      document.querySelector(".initCreatePromo").disabled = true
    },
    changeDeparments(event){
      const $this = this;
      const select = event.target
      const value = select.value;
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const parameters = {
        "departamento": value,
      }
      document.querySelector(".form_laive").classList.add("validateClient")
      let apiProvincia = process.env.VUE_APP_API_URL+"/estudio/provincias"
      axios.post(apiProvincia, parameters,config)
      .then(function (response){
        document.querySelector(".form_laive").classList.remove("validateClient")
        const data = response.data
        $this.provincias = data
        console.log({data})
      }).catch(errors => {
        document.querySelector(".form_laive").classList.remove("validateClient")
        console.error("error")
      })
    },
    changeProvincias(event){
      const $this = this;
      const select = event.target
      const value = select.value;
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const parameters = {
        "departamento": $this.grupoObjetivo.departamento,
        "provincia": value
      }
      document.querySelector(".form_laive").classList.add("validateClient")
      let apiDistritos = process.env.VUE_APP_API_URL+"/estudio/distritos"
      axios.post(apiDistritos, parameters,config)
      .then(function (response){
        document.querySelector(".form_laive").classList.remove("validateClient")
        const data = response.data
        $this.distritos = data
        console.log({data})
      }).catch(errors => {
        document.querySelector(".form_laive").classList.remove("validateClient")
        console.error("error")
      })
      console.log({value})
    },
    selectAllCheckboxes(e){
      const elm = e.target
      let ifChecked = elm.checked
      let parent = elm.parentElement.parentElement
      let objectVal;
      console.log(elm.value)
      switch (elm.value) {
        case "allDis":
          objectVal = this.selectDistribuidoras
          break;
        case "allTipoCliente":
          objectVal = this.selectTipoCliente
          break;
        case "allGiros":
          objectVal = this.selectGiros
          break;
        case "allSegment":
          objectVal = this.selectSegmentos
          break;
        case "allCluster":
          objectVal = this.selectCluster
          break;
        case "allDias":
          objectVal = this.selectDias
          break;
        default:
          break;
      }
      objectVal.splice(0,objectVal.length);
      if(ifChecked){
        parent.querySelectorAll(".custom-control-input.item").forEach(item => {
          item.checked = ifChecked
          objectVal.push(item.value)
        });
      }
    },
    addFile(file){
      var idxDot = file.name.lastIndexOf(".") + 1;
      var extFile = file.name.substr(idxDot, file.name.length).toLowerCase();
      //console.log({file, idxDot, extFile});
      if(extFile == 'csv' || extFile == 'xlsx' || extFile == 'xls'){
        const template = `<h4>${file.name}</h4>`
        document.querySelector(".block_inner_inmport").innerHTML = template
        this.filePromo = file
      }else{
        const content = {
          component: Notification,
          props: {
            icon: 'ni ni-bell-55',
            text: `El formato ${extFile} no es válido`,
            type: "danger",
          },
        };
        const toast = useToast();
        toast(content, {
          hideProgressBar: true,
          icon: false,
          closeButton: false,
          position: "top-right",
        });
      }
    },
    clickUpdateName(){
      this.updateNameEstudio = true
    },
    cancelFormUpdate(){
      this.nameEstudio = this.$route.query.name
      this.updateNameEstudio = false
    },
    submitNameEstudio(){
      const $this = this
      const idStudio = this.$route.params.id
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      let parameters = {
        idEstudio: idStudio,
        nombre: this.nameEstudio
      }
      document.querySelector(".form_laive").classList.add("validateClient")
      let apiNameUpdate = process.env.VUE_APP_API_URL+"/estudio/actualizar/nombre"
      axios.post(apiNameUpdate,parameters,config)
      .then(function(response){
        let data = response.data
        $this.$router.replace({name: "Editar Formulario", query: {name: $this.nameEstudio}})
        document.querySelector(".form_laive").classList.remove("validateClient")
      }).catch(errors => {
        console.log({errors})
        document.querySelector(".form_laive").classList.remove("validateClient")
      })
      this.updateNameEstudio = false
    }
  },
  async mounted() {
    await this.getTipoDePregunta();
    await this.getdataPreguntasLista();
  },
  data() {
    return {
      createGroup: false,
      resumeGrupo: false,
      uploadFile: false,
      selectDistribuidoras: [],
      selectTipoCliente: [],
      selectGiros: [],
      selectSegmentos: [],
      selectCluster: [],
      selectDias: [],
      tiposCliente: [],
      clusters: [],
      departamentos: [],
      provincias: [],
      distritos: [],
      distribuidoras: [],
      segmentos: [],
      giros: [],
      productoAsociado: false,
      configDate: {
        altInput: true,
        allowInput: true,
        locale: Spanish, // locale for this instance only
      },
      configDropZone:{
        dictDefaultMessage: `<div class='block_inner_inmport'>
                                  <h4>Elige un archivo</h4>
                                  <div class='box_icon'>
                                    <i class='far fa-file-alt'></i>
                                  </div>
                                  <p class="text">o suelta el excel aquí</p>
                                </div>`,
        acceptedFiles: "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      filePromo:[],
      grupoObjetivo:{
        "idEstudio": "",
        "idDistribuidora": "",
        "giroNegocio": "",
        "segmento": "",
        "cluster": "",
        "tipoCliente": "",
        "departamento": "",
        "provincia": "",
        "distrito": "",
        "tipo": 1,
        "fechaInicio": "",
        "fechaFin": ""
      },
      tableColumns: [
        {
          prop: "distribuidora",
          label: "Distribuidora",
          minWidth: 120,
        },
        {
          prop: "cantidad",
          label: "Cantidad de entrevistados",
          minWidth: 120,
        },
      ],
      nameEstudio: "",
      updateNameEstudio: false,
      tableData: [],
      tipoPreguntas:[],
      dataPreguntas:{
        idEstudio:0,
        isNew:true,
        preguntas:[
          {
            "id":"preg_1",
            "title":"",
            "type":"multiple",
            "required":false,
            "options":[
            ],
            "condition":null
          },
        ]
      },
    };
  },
}
</script>
